import * as React from "react";
import { useCallback, useMemo } from "react";
import { Icon } from "components/common";
import { Button } from "components/bootstrap";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import { removeIlluminateEventDefinitionPrefix } from "security-app/components/Investigations/Details/TimelineSegment/Utils";
import Routes from "routing/Routes";
import useSendEventActionTelemetry from "components/events/events/hooks/useSendEventActionTelemetry";
import EvidenceCardFoundation from "./EvidenceCardFoundation";
import EvidenceFields from "./EvidenceFields";
const EvidenceEventCard = ({
  evidence,
  onShowSimilar,
  onResetShowSimilar,
  similarFieldsFilter
}) => {
  var _a;
  const { permissions } = useCurrentUser();
  const sendEventActionTelemetry = useSendEventActionTelemetry();
  const canSeeEventDefinition = useMemo(
    () => isPermitted(permissions, `eventdefinitions:read:${evidence.entity.event_definition_id}`),
    [evidence, permissions]
  );
  const onReplaySearch = useCallback(() => {
    sendEventActionTelemetry("REPLAY_SEARCH", false);
    window.open(Routes.ALERTS.replay_search(evidence.entity.id), "_blank");
  }, [evidence.entity.id, sendEventActionTelemetry]);
  const { matching_fields: similarFields } = (_a = similarFieldsFilter == null ? void 0 : similarFieldsFilter.fields.events.find(
    ({ event: { id } }) => id === evidence.id
  )) != null ? _a : { matching_fields: [] };
  const subtitle = evidence.entity.message.replace(new RegExp(`^${evidence.entity.message}: `, "i"), "");
  return /* @__PURE__ */ React.createElement(
    EvidenceCardFoundation,
    {
      title: removeIlluminateEventDefinitionPrefix(evidence.entity.message),
      subtitle,
      actions: evidence.entity.replay_info && canSeeEventDefinition ? /* @__PURE__ */ React.createElement(Button, { onClick: onReplaySearch, bsSize: "small" }, /* @__PURE__ */ React.createElement(Icon, { name: "play_arrow" }), " Replay Search") : null,
      onResetShowSimilar,
      hasSimilarFieldsFilter: !!similarFieldsFilter,
      evidence,
      onShowSimilar,
      isHighlighted: (similarFieldsFilter == null ? void 0 : similarFieldsFilter.targetEvidence.id) === evidence.id,
      canSeeEventDefinition
    },
    evidence.entity.fields && /* @__PURE__ */ React.createElement(EvidenceFields, { similarFieldsFilterValue: similarFields, fields: evidence.entity.fields })
  );
};
export default EvidenceEventCard;
